import { useEffect, useRef } from "react";

/**
 * Tiny redirector for the direct Google OAuth flow.
 *
 * Google sends the user back to https://astrokuberchat.com/auth/google?code=...&state=...
 * (the URI we registered in the OAuth Client). This component just forwards
 * the entire query string to the backend callback which sets the
 * session_token cookie and bounces the user back to the destination.
 *
 * IMPORTANT: useEffect runs TWICE under React.StrictMode in dev — the ref
 * guard below ensures we only navigate once so the one-time-use OAuth state
 * isn't consumed twice (which would produce "Invalid or expired state").
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleAuthCallback() {
  const navigated = useRef(false);
  useEffect(() => {
    if (navigated.current) return;
    navigated.current = true;
    const qs = window.location.search || "";
    window.location.replace(`/api/auth/google/callback${qs}`);
  }, []);

  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-[#FAF4E8] text-[#3F2D1B]">
      <div className="text-center" data-testid="google-auth-callback">
        <div className="font-serif-display text-2xl mb-2">Signing you in…</div>
        <div className="text-sm text-muted">Verifying your Google account.</div>
      </div>
    </div>
  );
}
